export default __webpack_public_path__ + "static/media/billing.2b2a9b9a.svg";